<template>
    <div class="contactsSearch-box">
        <div class="search-box" :class="{ focus: isFocused }">
            <img
                src="../../../assets/images/contacts/org-search.png"
                alt=""
                class="search-icon"
            >
            <input
                v-model="keyword"
                maxlength="30"
                type="text"
                class="search-ipt"
                placeholder="搜索"
                @focus="isFocused = true"
                @blur="isFocused = false"
                @input="searchHandle()"
            >
            <div v-if="showSearchDel" class="search-delete" @click="clearInput">
                <img
                    src="../../../assets/images/contacts/org-search-delete.png"
                    alt=""
                    class="search-del"
                >
                <img
                    src="../../../assets/images/contacts/org-search-delete-hover.png"
                    alt=""
                    class="search-del-hover"
                >
            </div>
        </div>
        <div v-show="showSearchResult" class="search-result">
            <div class="tabs">
                <p class="tabs-box">
                    <a
                        v-for="item in tabsItem"
                        :key="item.name"
                        class="tabs-item"
                        :class="item.name === activeTabs ? 'active' : ''"
                        @click="changeTabs(item)"
                    >{{ item.title }}</a>
                    <i class="active-line" :class="activeTabs" />
                </p>
            </div>
            <div class="result">
                <keep-alive>
                    <SearchAll
                        v-if="activeTabs === 'all'"
                        ref="searchAll"
                        :selected="selected"
                        :is-staff="isStaff"
                        :login-rights="loginRights"
                        :default-selected="defaultSelected"
                        :can-not-selected="canNotSelected"
                        :selected-half-groups="selectedHalfGroups"
                        :selected-groups="selectedGroups"
                        :group-select-type="groupSelectType"
                        :keyword="keyword"
                        @changeTabs="changeTabs"
                        @checkContacts="checkContacts"
                        @checkGroups="checkGroups"
                    />
                    <SearchContacts
                        v-if="activeTabs === 'contacts'"
                        ref="searchContacts"
                        :selected="selected"
                        :is-staff="isStaff"
                        :login-rights="loginRights"
                        :default-selected="defaultSelected"
                        :can-not-selected="canNotSelected"
                        :group-select-type="groupSelectType"
                        :keyword="keyword"
                        @checkContacts="checkContacts"
                    />
                    <SearchGroups
                        v-if="activeTabs === 'groups'"
                        ref="searchGroups"
                        :selected-half-groups="selectedHalfGroups"
                        :selected-groups="selectedGroups"
                        :keyword="keyword"
                        @checkGroups="checkGroups"
                    />
                </keep-alive>
            </div>
        </div>
    </div>
</template>

<script>
import { getGroups } from '@/apis/contactsWindow/contactsWindow'
import SearchAll from './SearchAll'
import SearchContacts from './SearchContacts'
import SearchGroups from './SearchGroups'

export default {
    name: 'ContactsSearch',
    components: {
        SearchAll,
        SearchContacts,
        SearchGroups
    },
    props: {
        selected: {
            type: [Array],
            required: false,
            default: () => []
        },
        countLimit: {
            type: [Number],
            required: true
        },
        isStaff: {
            type: Boolean,
            required: true,
            default: false
        },
        loginRights: {
            type: Object,
            required: true
        },
        defaultSelected: {
            type: [Array],
            required: false,
            default: () => []
        },
        canNotSelected: {
            type: [Array],
            required: false,
            default: () => []
        },
        selectedGroups: {
            type: [Array],
            required: false,
            default: () => []
        },
        selectedHalfGroups: {
            type: [Array],
            required: false,
            default: () => []
        },
        groupSelectType: {
            type: [Number],
            required: true
        }
    },
    data() {
        return {
            isFocused: false,
            tabsItem: [
                {
                    title: '全部',
                    name: 'all'
                },
                {
                    title: '联系人',
                    name: 'contacts'
                },
                {
                    title: '群聊',
                    name: 'groups'
                }
            ],
            activeTabs: 'all',
            keyword: '',
            showSearchDel: false, // 是否展示搜索清空icon
            showSearchResult: false, // 是否展示搜索结果页
            timer: '',
            groupMembersCache: {} // 缓存群成员
        }
    },
    computed: {
        selectedIdList: {
            get() {
                return this.selected.map(item => item.id)
            },
            set() {}
        },
        selectedGroupIdList: {
            get() {
                return this.selectedGroups.map(item => item.id)
            },
            set() {}
        },
        defaultIdList() {
            return (this.defaultSelected || []).map(item => item.id)
        },
        canNotSelectedIds() {
            return this.canNotSelected || []
        },
        // 是否有通讯录权限:-1无权限;0低权限;1高权限
        userLevel() {
            return !this.loginRights.authorityGrade
                ? -1
                : +this.loginRights.authorityGrade
        }
    },
    mounted() {},
    methods: {
        changeTabs(item) {
            this.activeTabs = item.name
            this.$nextTick(() => {
                this.getSearch(true) // 切换tab不延迟
            })
        },
        getSearch(isChangeTab) {
            if (this.activeTabs === 'all') {
                this.$refs.searchAll.getData(this.keyword, isChangeTab)
            } else if (this.activeTabs === 'contacts') {
                this.$refs.searchContacts.getData(this.keyword, isChangeTab)
            } else if (this.activeTabs === 'groups') {
                this.$refs.searchGroups.getData(this.keyword, isChangeTab)
            }
        },
        // input值变更事件
        searchHandle() {
            this.clearTimeout()
            if (this.keyword === '') {
                this.clearInput()
            } else if (!this.keyword.trim()) {
                this.keyword = ''
                this.clearInput()
            } else {
                // this.keyword = this.keyword.trim()
                this.showSearchDel = true
                this.showSearchResult = true
                // this.throttle()
                this.timer = setTimeout(() => {
                    this.getSearch()
                }, 300)
            }
        },
        clearTimeout() {
            if (this.timer) {
                clearTimeout(this.timer)
            }
        },
        // 节流
        // throttle() {
        //     const context = this
        //     // 清除上一次setTimeout
        //     if (context.timer) {
        //         clearTimeout(context.timer)
        //     }
        //     context.timer = setTimeout(() => {
        //         context.getSearch()
        //     }, 300)
        // },
        // 清空input值
        clearInput() {
            this.keyword = ''
            this.showSearchDel = false
            this.showSearchResult = false
            this.activeTabs = this.tabsItem[0].name
        },
        // 点击常用联系人
        checkContacts(event, item) {
            const checked = event.target.checked
            const context = this
            if (checked) {
                if (context.countLimit) {
                    const count = context.selected.length + 1
                    if (count > context.countLimit) {
                        context.$nextTick(() => {
                            // 人数超了不需要选中
                            event.target.checked = false
                        })
                        context.$emit('maxCountLimit')
                        return
                    }
                }
                // 先添加到 selected 列表中
                context.$emit('added', [item])
            } else {
                // 先 remove selected
                context.$emit('removed', [item])
                // 触发父组件取消选中时的勾选状态计算
                // this.$parent.deleteSelectedList([item])
            }
        },
        // 点击群组
        checkGroups(event, groupItem) {
            groupItem.id = groupItem.targetId
            const checked = event.target.checked
            const context = this
            let member = []
            if (checked) {
                // 默认设置false，防止接口异步响应会先选中再取消
                event.target.checked = false
            }
            if (context.groupSelectType === 0) {
                // 是否转发，0选人，1转发选群
                const memberFunc = memberData => {
                    member = this.formatUserData(memberData).filter(val => {
                        return !this.isDisabled(val)
                    })
                    if (checked) {
                        if (context.countLimit) {
                            // 排除已选的群成员
                            const selectedIdList = context.selected.map(
                                item => item.id
                            )
                            const memberCountWithout = member.filter(item => {
                                return selectedIdList.indexOf(item.uId) < 0
                            })
                            const count =
                                context.selected.length +
                                memberCountWithout.length
                            if (count > context.countLimit) {
                                context.$emit('maxCountLimit')
                                return
                            }
                        }
                        addMembers(member, context)
                        context.$emit('addedGroup', [groupItem])
                        // 深拷贝一下，然后把群成员塞进去存一下
                        const group = JSON.parse(JSON.stringify(groupItem))
                        const memberIdList = []
                        for (let i = 0; i < member.length; i++) {
                            if (!this.isDisabled(member[i])) {
                                memberIdList.push(member[i].id)
                            }
                        }
                        group.memberList = memberIdList
                        context.$emit('saveGroupsList', [group])
                        event.target.checked = true
                    } else {
                        // 非转发remove 群里的人
                        context.$emit('removed', member)
                        context.$emit('removedGroup', [groupItem])
                    }
                }
                // 如果有组件缓存数据，使用组件缓存数据
                if (context.groupMembersCache[groupItem.id]) {
                    const memberData = context.groupMembersCache[groupItem.id]
                    memberFunc(memberData)
                    return
                }
                getGroups(groupItem.id)
                    .then(res => {
                        if (res.code === '0') {
                            const memberData = res.data.staffs // 存放群内所有成员的信息
                            context.groupMembersCache[groupItem.id] = memberData
                            memberFunc(memberData)
                        } else {
                            this.$message({
                                message: res.message,
                                type: 'error',
                                duration: 3000
                            })
                            context.$nextTick(() => {
                                // 获取失败不需要选中
                                event.target.checked = false
                            })
                        }
                    })
                    .catch(err => {
                        console.warn(err)
                        context.$message({
                            message: '获取群信息失败',
                            type: 'error',
                            duration: 3000
                        })
                    })
            } else {
                if (checked) {
                    if (context.countLimit) {
                        // 排除已选的群成员
                        const count = context.selected.length
                        if (count > context.countLimit) {
                            context.$emit('maxCountLimit')
                            return
                        }
                        context.$emit('addedGroup', [groupItem])
                        context.$emit('added', [groupItem])
                    }
                } else {
                    // 转发remove整个群
                    context.$emit('removed', [groupItem])
                    context.$emit('removedGroup', [groupItem])
                }
            }
        },
        // 格式化从后端获取的数据
        formatUserData(list) {
            const tempList = []
            for (let i = 0; i < list.length; i++) {
                let obj = {}
                if (list[i].uId) {
                    // list[i].lxAccount这个判断是为了兼容获取群详情里的staffs时format数据
                    obj = {
                        uId: list[i].uId || '',
                        id: list[i].uId || '',
                        headId: list[i].headId || '',
                        portraitUrl: list[i].portraitUrl || '',
                        name: list[i].name || '',
                        lxAccount: list[i].lxAccount || '',
                        userType: +list[i].userType || '',
                        isExec: +list[i].isExec || 0,
                        job: list[i].job || list[i].tag1 || '',
                        status: 1 // 后端已过滤，默认给1，在职
                    }
                    tempList.push(obj)
                }
            }
            return tempList
        },
        /* 成员的禁用状态，是否可选择、取消。 1.默认选中成员 */
        isDisabled(item) {
            return (
                this.isDefault(item) ||
                this.isDelete(item) ||
                this.executiveLimit(item) ||
                this.isCannotSelected(item)
            )
        },
        isDefault(item) {
            return this.defaultIdList.indexOf(item.id) >= 0
        },
        isDelete(item) {
            const isDelete = item && +item.status !== 1 // status是0或2的人不能被选中 0离职2禁用
            return isDelete
        },
        executiveLimit(item) {
            if (this.isStaff && this.userLevel >= 1) {
                return false
            }
            const isExec = item && !!+item.isExec
            return isExec
        },
        isCannotSelected(item) {
            return this.canNotSelectedIds.indexOf(item.id) >= 0
        },
        isHalf(item) {
            const idList = this.selectedHalfGroups.map(item => item.id)
            return idList.indexOf(item.targetId) > -1
        }
    }
}
function addMembers(members, context) {
    members = members.filter(item => !context.isDisabled(item))
    // 先给 members 去重
    members = uniq(members)
    members = without(members, context.selected)
    if (members.length > 0) {
        context.$emit('added', members)
    }
}
function uniq(array) {
    const map = {}
    return array.filter(item => {
        const id = item.id
        if (map[id]) {
            return false
        }
        map[id] = id
        return true
    })
}

function without(members, others) {
    const otherIds = others.map(item => item.id)
    return members.filter(item => otherIds.indexOf(item.id) < 0)
}
</script>

<style lang="scss" scoped>
input,
input:focus {
    outline: none !important;
}
.contactsSearch-box {
    width: 336px;
    position: relative;
    .search-box {
        display: flex;
        align-items: center;
        border-radius: 2px;
        border: 1px solid #eaeaea;
        box-sizing: border-box;
        width: 100%;
        height: 30px;
        transition: border-color 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);
        &.focus {
            border-color: #007af5;
        }
        .search-icon {
            width: 18px;
            height: 18px;
            margin: 0 6px 0 12px;
        }
        .search-ipt {
            flex: 1;
            font-size: 12px;
            //line-height: 22px;
            color: #323232;
            border: 0;
        }
        input::-webkit-input-placeholder {
            color: #c1c1c1;
        }
        .search-delete {
            width: 12px;
            height: 12px;
            margin-right: 9px;
            cursor: pointer;
            display: flex;
            &:hover {
                .search-del {
                    display: none;
                }
                .search-del-hover {
                    display: inline-block;
                }
            }
            .search-del,
            .search-del-hover {
                width: 12px;
                height: 12px;
            }
            .search-del-hover {
                display: none;
            }
        }
    }
    .search-result {
        position: absolute;
        z-index: 1;
        width: 360px;
        height: 450px;
        top: 30px;
        left: -12px;
        background: #fff;
        display: flex;
        flex-direction: column;
        box-shadow: inset -1px 0px 0px #f5f5f5;
        .tabs {
            flex-shrink: 0;
            padding: 0 12px;
            .tabs-box {
                width: 100%;
                height: 48px;
                display: flex;
                align-items: center;
                box-sizing: border-box;
                border-bottom: 1px solid #f5f5f5;
                position: relative;
                .tabs-item {
                    padding: 13px 0;
                    font-size: 14px;
                    line-height: 22px;
                    color: #323232;
                    margin-left: 30px;
                    cursor: pointer;
                    &:first-child {
                        margin-left: 0;
                    }
                    &.active {
                        font-weight: 600;
                        color: #007af5;
                    }
                }
                .active-line {
                    width: 24px;
                    height: 2px;
                    position: absolute;
                    bottom: 0;
                    background: #007af5;
                    transition: left 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
                    &.all {
                        left: 2px;
                    }
                    &.contacts {
                        left: 66px;
                        /*left: 8px;*/
                    }
                    &.groups {
                        left: 132px;
                        /*left: 73px;*/
                    }
                }
            }
        }
        .result {
            flex: 1;
            overflow: hidden;
        }
    }
}
</style>
